/**
 * The caps on one model-authored visualization (ADR 0013). They bound what the model can send, what
 * a browser is asked to run, and what comes back; every layer (the assistant's checks, the api's
 * report checks, the runner, the host) enforces the ones it can see.
 */
export const VIZ_LIMITS = {
  /** The d3 source, in UTF-16 code units. */
  codeChars: 32_768,
  /** The data payload, as JSON, in characters. */
  dataChars: 262_144,
  /** Rows of the data payload (when it is an array). */
  dataRows: 5_000,
  /** The SVG markup the worker returns, in characters. */
  svgChars: 2_000_000,
  /** Elements in the returned SVG. */
  svgElements: 20_000,
  /** Wall-clock time of one render in the worker; the worker is terminated after it. */
  timeoutMs: 5_000,
  /** Title length. */
  titleChars: 200,
  /** Card height in px: min, default, max. */
  height: { min: 120, default: 320, max: 1200 },
  /** Card width in px the code draws for: min, default, max. */
  width: { min: 200, default: 640, max: 2000 },
} as const;

/** Where apps/web serves the runner page (its own response headers; see `@cortex/viz/runner`). */
export const VIZ_RUNNER_PATH = '/viz-runner/';

/** The protocol version runner and host must share. */
export const VIZ_PROTOCOL = 1;
